import React from 'react';
import classNames from 'clsx';
import { Fade, InputAdornment } from '@material-ui/core';
import ChevronDown from 'mdi-material-ui/ChevronDown';

import { EndAdornmentProps } from './EndAdornment.interface';
import { useStyles } from './EndAdornment.styles';

export default function EndAdornment({ open, hidden }: EndAdornmentProps) {
  const classes = useStyles();

  return (
    <Fade in>
      <InputAdornment
        className={classNames(classes.endAdornment, {
          [classes.hidden]: hidden,
        })}
        disablePointerEvents
        position="end"
      >
        <ChevronDown
          className={classNames(classes.chevron, {
            [classes.chevronUp]: open,
          })}
        />
      </InputAdornment>
    </Fade>
  );
}
